import type { App } from '@grafikr/components';
import Cart from 'utils/cart';

export default (app: App) => {
  app.emitter.on('cart:added', async () => {
    const { data } = await Cart.get();

    if (data) {
      theme.cart = data;
      app.emitter.emit('cart:updated', data);
    }
  });

  app.emitter.on('cart:changed', async () => {
    const { data } = await Cart.get();

    if (data) {
      theme.cart = data;
      app.emitter.emit('cart:updated', data);
    }
  });

  document.addEventListener('cart:changed', async () => {
    const { data } = await Cart.get();

    if (data) {
      theme.cart = data;
      app.emitter.emit('cart:updated', data);
    }
  });
};
